import { render } from "./EventLocation.vue?vue&type=template&id=e7aad40a"
import script from "./EventLocation.vue?vue&type=script&lang=js"
export * from "./EventLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__